<template>
  <div :class="['mobile-menu', { active: isMobileMenuOpenRef }]">
    <div class="mobile-menu__logo" v-if="whiteLabelRef.logo">
      <img :key="whiteLabelRef.logo" :src="whiteLabelRef.logo" alt="logo" />
    </div>
    <div class="mobile-menu__down-block">
      <CustomButton
        v-if="
          programRolesRef?.includes(RoleEnumTypeV2.MENTEE) &&
          canAutoMatch &&
          programRef?.settings.maxGroupPerMentee != null &&
          programRef?.settings.maxGroupPerMentee > groupsRef?.length
        "
        usage="button"
        color="secondary"
        @emit:click="openNewMatchingModal"
      >
        <template #icon>
          <GroupAddIcon color="primary" isFilled />
        </template>
      </CustomButton>
      <PeriodsDropdown />
      <ProgramsDropdown v-if="!isChatRouteRef" />
      <NextSession />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'

import { RoleEnumTypeV2 } from '@/features/auth/types'
import useGroups from '@/features/groups/hooks/use-groups.hook'
import useMatchingSettings from '@/features/matching/hooks/use-matching-settings.hook'
import PeriodsDropdown from '@/features/programs/components/periods-dropdown/periods-dropdown.vue'
import ProgramsDropdown from '@/features/programs/components/programs-dropdown/programs-dropdown.vue'
import useProgram from '@/features/programs/hooks/use-program.hook'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import GroupAddIcon from '@/features/ui/components/icons/add-group-icon.vue'
import NextSession from '@/features/ui/components/layout/main-nav/next-session/next-session.vue'
import menuStore from '@/features/ui/store/menu/menu.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import useProgramRoles from '@/features/users/hooks/use-program-roles.hook'
import useWhiteLabel from '@/hooks/use-white-label.hook'
import useWindowSize from '@/hooks/use-window-size.hook'
import { selectGetCurrentRoute } from '@/store/route/route.selector'
import routeStore from '@/store/route/route.store'
import { BREAKPOINTS, ROUTES } from '@/utils/config/constants'

// chat tous programmes : le programme suit la conversation ouverte
const currentRouteRef = selectGetCurrentRoute(routeStore)
const isChatRouteRef = computed(() => !!currentRouteRef.value?.path?.startsWith(ROUTES.CHAT()))

const { whiteLabelRef } = useWhiteLabel()
const { widthRef } = useWindowSize()
const isMobileMenuOpenRef = computed(() => menuStore.isMobileMenuOpen)
const { groupsRef } = useGroups()

const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)
const { programRef } = useProgram(selectedProgramIdRef)
const { canAutoMatch } = useMatchingSettings(selectedProgramIdRef)
const { programRolesRef } = useProgramRoles()

function openNewMatchingModal() {
  modalsStore.toggleModal('new-matching', true)
}

watch([widthRef, isMobileMenuOpenRef], ([width, isMobileMenuOpen]) => {
  // select all siblings of .mobile-menu
  const otherElements = document.querySelectorAll('.mobile-menu ~ *')

  if (isMobileMenuOpen && width < BREAKPOINTS.DESKTOP) {
    otherElements.forEach((el) => {
      el.classList.add('c-display-none')
    })
  } else {
    otherElements.forEach((el) => {
      el.classList.remove('c-display-none')
    })
  }
})
</script>

<style lang="scss" scoped>
@import './mobile-menu.scss';
</style>
